<template>
  <v-container>
    <v-breadcrumbs divider=">"></v-breadcrumbs>

    <v-row v-if="loading">
      <v-col cols="12">
        <v-skeleton-loader type="card"></v-skeleton-loader>
      </v-col>
      <v-col cols="12">
        <v-skeleton-loader type="card"></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row class="text-center">
      <v-col class="mb-5" cols="12">
        <h2 class="headline font-weight-bold mb-3">
          ブログ
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" v-for="content in contents" :key="content.link">
        <v-card elevation="3">
          <v-card-title>
            {{ content.title }}
          </v-card-title>
          <v-card-subtitle>
            <v-spacer></v-spacer>
            <span>
              {{ new Date(content.pubDate).toLocaleString() }}
            </span>
          </v-card-subtitle>
          <v-card-text>
            <div v-html="content.description"></div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
export default {
  name: "Blog",
  data: () => ({
    isActive: false,
    contents: [],
    loading: true,
  }),
  mounted() {
    fetch('/api/blogs')
      .then(response => {
        return response.json();
      }).then(json => {
        console.log(json);

        this.contents = JSON.parse(json).rss.channel.item;
        console.log(this.contents[0].description);

        this.loading = false;

      }).catch(function (error) {
        console.log(error);
      });

  }
}
</script>
  